"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.65 1.008A.859.859 0 118.96.709a.859.859 0 011.69.299zM9.54 2.31c-2.768-.315-4.504 1.046-5.207 4.083C3.631 9.429 2.39 11.142.611 11.53c-.72.466-.804.938-.25 1.417.83.719 3.471 1.852 6.87 2.451l.061.011.01.002c3.4.6 6.269.438 7.295.047.684-.261.767-.733.25-1.418-1.539-.974-2.12-3.008-1.741-6.102.378-3.093-.787-4.966-3.495-5.617l-.072-.012zM4.602 15.678a3.044 3.044 0 00-.206.709 2.576 2.576 0 005.072.894c.043-.242.051-.541.027-.774 0 0-1.18-.078-2.452-.303-1.273-.224-2.441-.526-2.441-.526z",
    fill: "#fff"
  }));
}

var MemoSvgBell = /*#__PURE__*/React.memo(SvgBell);
var _default = MemoSvgBell;
exports["default"] = _default;